import React, { Component } from 'react';
//import PropTypes from 'prop-types';
import { Field, reduxForm } from 'redux-form'
import { Redirect } from 'react-router'
import { Link } from 'react-router-dom'

class LoginFormView extends Component {

  render() {

    document.body.className = window.location.pathname.replace(/\//g," ");

    if (this.props.current_user_id !== undefined){
      return (<Redirect to="/snap-photo" />)
    }else{
      return (

      <div className="width">
          <div className="container topbar">
              <div className="back"><a href="/">« back</a></div>
              <div className="title">Login</div>
          </div>
          <div className="padding-10x text-center">
            <form onSubmit={this.props.handleSubmit}>

              <p><Field component="input" type="text" name="email" placeholder='Email' /></p>

              <p><Field component="input" type="password" name="password" placeholder='Password'  /></p>

              {this.props.current_user.get("logging_in") === true ?
                  <span>Logging in...</span>
                  :
                  <button type="submit">Sign In</button>
              }
            </form>
          <div className="switch-login">
              <p>Have an access code? <Link to="/use-code">Enter It Here</Link></p>
          </div>
        </div>
      </div>

      )
    }
  }
}

LoginFormView.propTypes = {
  //
};

export default reduxForm({form: "Login"})(LoginFormView);



// WEBPACK FOOTER //
// ./src/snapit_app/components/LoginFormView.js